<template>
  <!-- <b-modal ref="modalSubstituerArticle" size="xl" title="Substitution d'article" hide-footer -->
  <b-modal ref="modalSubstituerArticle" size="xl" title="Substitution d'article"
      ok-title="Choisir" :ok-disabled="!choixValide"
      cancel-title="Annuler"
      no-close-on-backdrop
      @ok="valider()"> 
    <template slot="default">
      <div class="ml-1">
        <div class="row">
          <div class="col-2 small">Quantité demandée</div>
          <div v-if="articleSelectionne.produitId && articleSelectionne.designation" class="col-10 small">Article sélectionné pour substitution</div>
          <!-- <div v-else-if="articleOrigine.produitId" class="col-10 small">Article sélectionné</div> -->
          <div v-else class="col-10 small">Ingrédient sélectionné</div>
        </div>
        <div class="row">
          <div class="col-2">
            <h5>{{articleOrigine.quantiteBesoinEnUC}} {{articleOrigine.uc}}</h5>
          </div>
          <div class="col-10">
            <h5>
              {{articleSelectionne.produitId && articleSelectionne.designation ? articleSelectionne.designation.toUpperCase() : nomIngredient.toUpperCase()}}
              {{articleSelectionne.marque ? ' - ' + articleSelectionne.marque : ''}}
              {{articleSelectionne.fournisseurId ? ' - ' + fournisseurNom(articleSelectionne.fournisseurId) : ''}}<br />
              <span v-if="articleSelectionne.prixUnitaire && articleSelectionne.uc">({{articleSelectionne.prixUnitaire}} € / {{articleSelectionne.uc}}, prix total: {{(articleOrigine.quantiteBesoinEnUC * articleSelectionne.prixUnitaire) | afficherPrix}})</span>
            </h5>
          </div>
        </div>
      </div>
      <div class="flex-start ml-1 mt-3 mb-1 small">Articles associés à l'ingrédient "{{nomIngredient}}"</div>
      <div v-if="articles.parProduit">
        <ArticlesParProduit :articles="articles.parProduit" :favoris="articles.favoris" :articleOrigine="articleOrigine" @selection-article="selectionnerArticle($event)" @validation-article="valider()" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import ArticlesParProduit from '@/components/Stock/ArticlesParProduit'
import { connecteData } from '@/mixins/connecteData'
import { fournisseurs } from '@/mixins/fournisseurs'
import { tousArticlesPour, tousArticlesFamilles } from '@/api/gpao/mercuriales'
import { mapGetters } from "vuex"
import { showAlerts } from "@/mixins/alerts"

export default {
  name: "ModalSubstitutionArticle",
  props: {
    gestionFavoriUniquement: Boolean,
    idsBloques: [] //Id des fournisseurs non sélectionnables
  },
  components: { ArticlesParProduit },
  mixins: [fournisseurs, connecteData, showAlerts],
  data() {
    return {
      articleOrigine: {},
      articles: {},
      nouvelArticle: {}
    }
  },
  computed: {
    ...mapGetters("definitions", ["obtenirIngredient"]),
    choixValide() {
      return this.articleSelectionne?.fournisseurId && (this.articleSelectionne.fournisseurId != this.articleOrigine?.fournisseurId || this.articleSelectionne.produitId != this.articleOrigine.produitId)
    },
    articleSelectionne() {
      return this.nouvelArticle  // Clarification du code à poursuivre plus tard => il s'agit en réalité d'un article fournisseur et non d'un produit Agap mais c'est utilisé dans les composants appelants sous ce nom
    },
    nomIngredient() {
      return this.obtenirIngredient(this.articleOrigine?.ingredientId)?.nom || ""
    }
  },
  methods: {
    // initialiserModale() {
    //   /*if (this.propIngredient) {
    //     this.ingredient = this.propIngredient
    //   }*/
    //   this.obtenirArticles(this.articleSelectionne)
    // },
    /*surFermeture() {
      this.$emit("sur-fermeture", { ingredient: this.ingredient, favorisModifies: this.favorisModifies })
    },*/
    async obtenirArticles(articleOrigine) {
      if (!articleOrigine)
        return

      let response = {}
      if (!articleOrigine.ingredientId) {
        response = await tousArticlesPour(this.etabCourantId, articleOrigine.produitId)
        response.data = [response.data]
      } else if (articleOrigine.familleId) {
        response = await tousArticlesPour(this.etabCourantId, articleOrigine.ingredientId, articleOrigine.familleId, articleOrigine.grammage)
        response.data = [response.data]
      } else {
        response = await tousArticlesFamilles(this.etabCourantId, articleOrigine.ingredientId, null, articleOrigine.grammage)
      }

      let nbArticles = 0
      let articles = { ingredientId: articleOrigine.ingredientId, parProduit: {}, favoris: [] }
      response.data.forEach(a => {
        for (let key in a.parProduit) {
          articles.parProduit[key] = a.parProduit[key]
          articles.parProduit[key].forEach(p => { p.familleId = a.familleId })
        }
        if (a.favoris?.length) {
          articles.favoris.push(...a.favoris)
        }
      })
      for (let key in articles.parProduit) {
        let produits = articles.parProduit[key]
        nbArticles += produits.length
        produits.forEach(p => {
          if (this.idsBloques && this.idsBloques.indexOf(p.fournisseurId) !== -1) {
            p.bloque = true
          }
        })
      }
      this.articles = articles

      if (nbArticles > 0) {
        this.show()
      } else {
        this.$toast('Aucune substitution trouvée avec ces paramètres', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          className: ['toast-error'],
          duration: 1500
        })
      }
    },
    selectionnerArticle(elt) {
      this.nouvelArticle = elt
      //this.appliquerSelectionArticle(elt.produitId, elt.produit)
      //this.article = { produitId: elt.produitId, produit: elt.produit, estfavori: elt.estFavori }
    },
    // appliquerSelectionArticle(produitId, produit) {
    //   this.nouvelArticle = { produitId: produitId, produit: produit }
    // },
    valider() {
      if (!this.choixValide)
        return

      this.$emit('selection-article', { produitId: this.nouvelArticle.produitId, produit: this.nouvelArticle })
      this.hide()
    },
    show(articleOrigine) {
      if (articleOrigine) {
        this.obtenirArticles(articleOrigine)
        this.articleOrigine = articleOrigine
        this.nouvelArticle = {}
        if (this.articleOrigine.fournisseurId) {
          this.nouvelArticle = this.articleOrigine
          // this.appliquerSelectionArticle(this.articleOrigine.produitId, this.articleOrigine)
        }
        //this.article = { produitId: articleSelectionne.produitId, produit: articleSelectionne }
      }
      this.$refs.modalSubstituerArticle.show()
    },
    hide() {
      this.$refs.modalSubstituerArticle.hide()
    }
  }
}
</script>